import { render, staticRenderFns } from "./Etc.vue?vue&type=template&id=23640806"
import script from "./Etc.vue?vue&type=script&lang=js"
export * from "./Etc.vue?vue&type=script&lang=js"
import style0 from "./Etc.vue?vue&type=style&index=0&id=23640806&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports